import {useQuery} from "@tanstack/react-query";
import type {ClubStats, PlayersAgeCategory, PlayerStats, StatsRange, TournamentMetrics, TournamentTablesSlots} from '@iziping/common';
import type {ApiError} from '@iziping/common';
import { ENDPOINTS, QUERY_CACHE } from '@/model/endpoints';
import { apiClient } from '@iziping/common';

interface TablesStatisticsParams {
    tournamentId: number;
}

export const useGetTablesStatistics = (params: TablesStatisticsParams) => {
    return useQuery<TournamentTablesSlots, ApiError>({
        queryKey: [QUERY_CACHE.TABLES_STATISTICS],
        queryFn: async () => {
            const response = await apiClient.get<TournamentTablesSlots>(`${ENDPOINTS.tablesStatistics(params.tournamentId)}`);
            return response.data;
        },
        enabled: true,
    });
};

export const useGetClubsStatistics = (params: TablesStatisticsParams) => {
    return useQuery<ClubStats[], ApiError>({
        queryKey: [QUERY_CACHE.CLUBS_STATISTICS],
        queryFn: async () => {
            const response = await apiClient.get<ClubStats[]>(`${ENDPOINTS.statisticsClubs(params.tournamentId)}`);
            return response.data;
        },
        enabled: true,
    });
};

export const useGetPlayersStatistics = (params: TablesStatisticsParams) => {
    return useQuery<PlayerStats[], ApiError>({
        queryKey: [QUERY_CACHE.PLAYERS_STATISTICS],
        queryFn: async () => {
            const response = await apiClient.get<PlayerStats[]>(`${ENDPOINTS.statisticsPlayers(params.tournamentId)}`);
            return response.data;
        },
        enabled: true,
    });
};

export const useGetTournamentMetrics = (params: TablesStatisticsParams) => {
    return useQuery<TournamentMetrics[], ApiError>({
        queryKey: [QUERY_CACHE.METRICS_STATISTICS],
        queryFn: async () => {
            const response = await apiClient.get<TournamentMetrics[]>(`${ENDPOINTS.statisticsMetrics(params.tournamentId)}`);
            return response.data;
        },
        enabled: true,
    });
};

export const useGetPlayersRange = (params: TablesStatisticsParams) => {
    return useQuery<StatsRange[], ApiError>({
        queryKey: [QUERY_CACHE.PLAYERS_RANGE_STATISTICS],
        queryFn: async () => {
            const response = await apiClient.get<StatsRange[]>(`${ENDPOINTS.statisticsPlayersRange(params.tournamentId)}`);
            return response.data;
        },
        enabled: true,
    });
};

export const useGetPlayersByAge = (params: TablesStatisticsParams) => {
    return useQuery<PlayersAgeCategory[], ApiError>({
        queryKey: [QUERY_CACHE.PLAYERS_BY_AGE_STATISTICS],
        queryFn: async () => {
            const response = await apiClient.get<PlayersAgeCategory[]>(`${ENDPOINTS.statisticsPlayersByAge(params.tournamentId)}`);
            return response.data;
        },
        enabled: true,
    });
};